import React, { useContext } from 'react';
import Inputs from 'components/inputs/inputs';
import AppContext from 'contexts/appContext';
import Config from 'utils/config';
import './appsMenu.css';

import image_softwareupdate from 'assets/images/softwareupdate.png';
import image_reporting from 'assets/images/reporting.png';
import image_run from 'assets/images/run.png';
import image_tasks from 'assets/images/tasks.png';
import image_add from 'assets/images/add.png';
import image_updatehistory from 'assets/images/updatehistory.png';
import image_report from 'assets/images/report.png';
import image_exceptions from 'assets/images/exceptions.png';
import image_contacts from 'assets/images/contacts.png';
import image_event from 'assets/images/event.png';
import image_enterprise from 'assets/images/enterprise.png';
import image_dealer from 'assets/images/dealer.png';
import image_store from 'assets/images/store.png';
import image_hierarchy from 'assets/images/hierarchy.png';
import image_license from 'assets/images/license.png';
import image_userprofile from 'assets/images/userprofile.png';
import image_users from 'assets/images/users.png';
import image_keys from 'assets/images/keys.png';
import image_dashboard from 'assets/images/dashboard.png';
import image_sitedashboard from 'assets/images/sitedashboard.png';
import image_registrationdashboard from 'assets/images/registrationdashboard.png';
import image_controlpanel from 'assets/images/controlpanel.png';
import image_rules from 'assets/images/rules.png';
import image_kpidashboard from 'assets/images/kpidashboard.png';
import image_analytic from 'assets/images/analytic.png';
import image_reportdesigner from 'assets/images/reportdesigner.png';
import image_myinformation from 'assets/images/myinformation.png';
import image_preferences from 'assets/images/preferences.png';
import image_myviews from 'assets/images/myviews.png';
import image_posiconnect from 'assets/images/posiconnect.png';
import image_datawarehouse from 'assets/images/datawarehouse.png';
import image_employees from 'assets/images/employees.png';
import image_manageemployees from 'assets/images/manageemployees.png';
import image_menu from 'assets/images/menu.png';
import image_boarding from 'assets/images/boarding.png';
import image_newstore from 'assets/images/newstore.png';

export default function AppMenu(props) {
  const { appState, setAppMenu } = useContext(AppContext);

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  const setMenu = (area) => {
    setAppMenu(area);
  };

  const renderMenuNav = () => {
    if (appState.menu.area.id === null || appState.menu.area.name === null) return null;
    else
      return (
        <>
          <AppMenuNavItem iconClass='icons8-circled-menu' onClick={appState.menu.isRestricted ? null : () => setMenu(null)} disabled={appState.menu.isRestricted}>
            Apps
          </AppMenuNavItem>
          {' / '}
          <AppMenuNavItem disabled>
            {appState.menu.area.name}
          </AppMenuNavItem>
        </>
      );
  };

  const renderMenuList = () => {
    switch (appState.menu.area.id) {
      case AppContext.Areas.BackofficeReports:
        return <BackofficeReportsMenu onCloseMenu={handleClose} />;
      case AppContext.Areas.SoftwareUpdate:
        return <SoftwareUpdatesMenu onCloseMenu={handleClose} />;
      case AppContext.Areas.Employees:
        return <EmployeesMenu onCloseMenu={handleClose} />;
      case AppContext.Areas.Menus:
        return <MenuMenu onCloseMenu={handleClose} />;
      case AppContext.Areas.Boarding:
        return <BoardingMenu onCloseMenu={handleClose} />;

      case AppContext.Areas.Views:
        return <ViewsMenu onCloseMenu={handleClose} />;
      case AppContext.Areas.POSiConnect:
        return <POSiConnectMenu onCloseMenu={handleClose} />;
      case AppContext.Areas.DataWarehouse:
        return <DataWarehouseMenu onCloseMenu={handleClose} />;

      default:
        return <MainMenu setMenu={setMenu} />;
    }
  };

  if (!props.open) return null;

  return (
    <>
      <div className={'app-menu' + (appState.menu.area.id === null || appState.menu.area.name === null ? '' : ' with-nav')}>
        <div className='app-menu-nav'>{renderMenuNav()}</div>
        <div className='app-menu-list'>{renderMenuList()}</div>
      </div>
      <div className='fade modal-backdrop show' style={{ marginTop: 60 }} onClick={handleClose}></div>
    </>
  );
}

function AppMenuItem(props) {
  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };

  const renderContent = (content) => {
    if (props.href) {
      return <a href={props.href}>{content}</a>;
    }
    return content;
  };

  return renderContent(
    <div className='app-menu-item' onClick={handleClick}>
      <div className='app-menu-item-icon'>
        <img src={props.icon} alt='i' />
      </div>
      <div className='app-menu-item-text'>{props.title}</div>
    </div>
  );
}

function AppMenuNavItem(props) {
  return (
    <Inputs.Button variant={(props.disabled ? ' btn-none' : '')} className='px-1 my-1' onClick={props.disabled ? null : props.onClick}>
      {!props.iconClass ? null : (
        <span className='small pr-1'>
          <i className={props.iconClass} />
        </span>
      )}
      {props.children}
    </Inputs.Button>
  );
}

function PortalMenuItem(props) {
  if (true) return null;

  const navigatePortalLink = () => (window.location.href = Config.portalURL + props.href);

  const onClick = props.onClick || navigatePortalLink;

  return (
    <div className='app-menu-item' onClick={onClick}>
      <div className='app-menu-item-icon'>
        <img src={props.icon} alt='i' />
      </div>
      <div className='app-menu-item-text'>{props.title}</div>
    </div>
  );
}

/*********************************** */

function MainMenu(props) {
  const setMenu = props.setMenu;

  return (
    <>
      <AppMenuItem title='Backoffice Reports' icon={image_reporting} onClick={() => setMenu(AppContext.Areas.BackofficeReports)} />
      <AppMenuItem title='Software Update' icon={image_softwareupdate} onClick={() => setMenu(AppContext.Areas.SoftwareUpdate)} />
      <AppMenuItem title='Employees' icon={image_employees} onClick={() => setMenu(AppContext.Areas.Employees)} />
      <AppMenuItem title='Menus' icon={image_menu} onClick={() => setMenu(AppContext.Areas.Menus)} />
      <AppMenuItem title='Boarding' icon={image_boarding} onClick={() => setMenu(AppContext.Areas.Boarding)} />

      <PortalMenuItem title='POSiConnect' icon={image_posiconnect} onClick={() => setMenu(AppContext.Areas.POSiConnect)} />
      <PortalMenuItem title='Data Warehouse' icon={image_datawarehouse} onClick={() => setMenu(AppContext.Areas.DataWarehouse)} />
      <PortalMenuItem title='Flash Reports' icon={image_report} href='/FlashReports.aspx#FlashReports' />
      <PortalMenuItem title='Exceptions' icon={image_exceptions} href='/Exceptions.aspx#Exceptions' />
      <PortalMenuItem title='Contacts' icon={image_contacts} href='/AppSetup.aspx#Contacts' />
      <PortalMenuItem title='Event Monitors' icon={image_event} href='/AppSetup.aspx#EventMonitors' />
      <PortalMenuItem title='Enterprises' icon={image_enterprise} href='/UserSetup.aspx#Enterprises' />
      <PortalMenuItem title='Dealers' icon={image_dealer} href='/UserSetup.aspx#Dealers' />
      <PortalMenuItem title='Stores' icon={image_store} href='/UserSetup.aspx#Stores' />
      <PortalMenuItem title='Hierarchy' icon={image_hierarchy} href='/UserSetup.aspx#Hierarchy' />
      <PortalMenuItem title='Licenses' icon={image_license} href='/UserSetup.aspx#Licenses' />
      <PortalMenuItem title='User Profiles' icon={image_userprofile} href='/UserSetup.aspx#UserProfiles' />
      <PortalMenuItem title='Users' icon={image_users} href='/UserSetup.aspx#Users' />
      <PortalMenuItem title='Security Keys' icon={image_keys} href='/Administration.aspx#SecurityKeys' />
      <PortalMenuItem title='Agent Dashboard' icon={image_dashboard} href='/AgentDashboard.aspx#Selection' />
      <PortalMenuItem title='Site Dashboard' icon={image_sitedashboard} href='/Dashboard.aspx#SiteDashboard' />
      <PortalMenuItem title='Registration Dashboard' icon={image_registrationdashboard} href='/Dashboard.aspx#RegistrationDashboard' />
      <PortalMenuItem title='My Information' icon={image_myinformation} href='/MyAccount.aspx#MyInformation' />
      <PortalMenuItem title='My Preferences' icon={image_preferences} href='/MyAccount.aspx#MyPreferences' />
    </>
  );
}

function BackofficeReportsMenu(props) {
  return (
    <>
      <AppMenuItem title='Run Report' icon={image_run} href='/BackofficeReports/Run' />
      <AppMenuItem title='Tasks' icon={image_tasks} href='/BackofficeReports/Tasks' />
      <AppMenuItem title='Create Task' icon={image_add} href='/BackofficeReports/Task/Create' />
    </>
  );
}

function SoftwareUpdatesMenu(props) {
  return (
    <>
      <AppMenuItem title='Update History' icon={image_updatehistory} href='/SoftwareUpdate' />
      <AppMenuItem title='Create Update' icon={image_add} href='/SoftwareUpdate/Create' />
    </>
  );
}

function EmployeesMenu(props) {
  return (
    <>
      <AppMenuItem title='Manage Employees' icon={image_manageemployees} href='/Employees' />
    </>
  );
}

function MenuMenu(props) {
  return (
    <>
      <AppMenuItem title='Manage Menus' icon={image_menu} href='/Menus' />
    </>
  );
}

function BoardingMenu(props) {
  return (
    <>
      <AppMenuItem title='Board New Sites' icon={image_newstore} href='/Boarding/Wizard' />
    </>
  );
}

function ViewsMenu(props) {
  return (
    <>
      <AppMenuItem title='My Views' icon={image_myviews} href='/Views/MyViews' />
    </>
  );
}

function POSiConnectMenu(props) {
  return (
    <>
      <PortalMenuItem title='Control Panel' icon={image_controlpanel} href='/POSiConnect.aspx#ControlPanel' />
      <PortalMenuItem title='Package Rules' icon={image_rules} href='/POSiConnect.aspx#Rules' />
    </>
  );
}

function DataWarehouseMenu(props) {
  return (
    <>
      <PortalMenuItem title='KPI Dashboard' icon={image_kpidashboard} href='/DataWarehouse.aspx#Dashboard' />
      <PortalMenuItem title='Analytics' icon={image_analytic} href='/DataWarehouse.aspx#ReportListing' />
      <PortalMenuItem title='Report Designer' icon={image_reportdesigner} href='/DataWarehouse.aspx#ReportDesigner' />
    </>
  );
}